/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressAutocompleteStateService {

  private extraData: any = null;
  private disabled = false;

  private extraDataStateSubject: BehaviorSubject<any> = new BehaviorSubject(this.extraData);
  private disabledStateSubject: BehaviorSubject<any> = new BehaviorSubject(this.disabled);

  get disabledStateChanged(): Observable<boolean> {
    return this.disabledStateSubject.asObservable();
  }

  get extraDataStateChanged(): Observable<any> {
    return this.extraDataStateSubject.asObservable();
  }

  constructor() { }

  resetState(disabled?: boolean, extraData?: any) {
    this.setExtraData(extraData);
    this.setDisabled(disabled ? disabled : false);
  }

  setExtraData(extraData: any) {
    this.extraDataStateSubject.next(extraData);
  }

  setDisabled(disabled: boolean) {
    this.disabledStateSubject.next(disabled);
  }
}
